import React, { useLayoutEffect } from 'react'
import Portal from './Portal'
import styles from './Modal.module.css'

const ModalContent = ({ children, isSmall }) => {
  useLayoutEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [])

  return (
    <Portal>
      <div className={styles.overlay}>
        <div className={`${styles.modal} ${isSmall && styles.center}`}>{children}</div>
      </div>
    </Portal>
  )
}

export default ModalContent
